import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import withMemo from '../../decorators/withMemo';
import { generateFieldsProps, getFieldTranslations, compileRules, defineField } from '../../helpers/FormHelpers';
import ScholarshipTemplate from '../../templates/Scholarship';
import Password from '../../components/form/fields/Password';
import { useHeader, useFooter } from '../../hooks/useAppLayout';
import { useNavPath } from '../../hooks/useNavPath';
import sagas from './sagas';
import { actions as scholarshipActions, selectors } from './redux';
var Scholarship = function Scholarship() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var headerProps = useHeader();
  var footerProps = useFooter();
  var navPathProps = useNavPath();
  var dispatch = useDispatch();
  var register = useSelector(selectors.register);
  var submitErrors = register == null ? void 0 : register.errors;
  var submitSuccess = register == null ? void 0 : register.success;
  var submitPending = register == null ? void 0 : register.pending;
  var layoutProps = {
    theme: {
      maxWidth: 640
    }
  };
  var pageTitleProps = {
    text: t('scholarship')
  };
  var paragraphProps = {
    text: t('scholarship_page_introduction')
  };
  var sections = [{
    type: 'fields',
    content: [defineField({
      name: 'code',
      validation: 'required',
      props: {
        type: 'text'
      }
    })]
  }, {
    type: 'fields',
    content: [defineField({
      name: 'email',
      validation: 'required|email',
      props: {
        type: 'text'
      }
    })]
  }, {
    type: 'fields',
    content: [defineField({
      name: 'password',
      validation: 'required',
      component: Password,
      props: {
        type: 'password'
      }
    })]
  }];
  var fields = sections.filter(function (section) {
    return section.type === 'fields';
  }).map(function (thisFields) {
    return thisFields.content;
  }).flat();
  var rules = compileRules(fields);
  var formRegistrationProps = useMemo(function () {
    return {
      fieldsProps: generateFieldsProps(fields, function (field) {
        var fieldProps = getFieldTranslations(t, "registration_form_".concat(field.name));
        return fieldProps;
      }),
      messages: {
        required: t('form_error_required'),
        email: t('form_error_email')
      },
      submitLabel: t('registration_form_submit_label'),
      submitPendingLabel: t('form_submit_pending_label'),
      submitSuccessLabel: t('form_submit_success_label'),
      submitErrors: submitErrors,
      submitSuccess: submitSuccess,
      submitPending: submitPending,
      sections: sections,
      fields: fields,
      rules: rules,
      onSubmit: function onSubmit(payload) {
        return dispatch(scholarshipActions.register(payload));
      }
    };
  }, [fields, t, submitErrors, submitSuccess, submitPending, sections, rules, dispatch]);
  var scholarshipTemplateProps = {
    headerProps: headerProps,
    navPathProps: navPathProps,
    footerProps: footerProps,
    layoutProps: layoutProps,
    pageTitleProps: pageTitleProps,
    paragraphProps: paragraphProps,
    formRegistrationProps: formRegistrationProps
  };
  return /*#__PURE__*/React.createElement(ScholarshipTemplate, scholarshipTemplateProps);
};
Scholarship.getInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ctx.store.saga.run(sagas.init, ctx).toPromise());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
Scholarship.propTypes = {};
Scholarship.defaultProps = {};
export default withMemo()(Scholarship);